import { FC } from "react";
import Button, { ButtonProperties } from "./Button";

type ButtonWithIconProps = {
  icon: React.ReactNode;
  textButton: string;
  position?: "left" | "right";
};

type ButtonProps = ButtonWithIconProps & ButtonProperties;

const ButtonWithIcon: FC<ButtonProps> = ({
  icon,
  textButton,
  position = "left",
  ...props
}) => {
  return (
    <Button icon={icon} iconPosition={position} {...props}>
      {textButton}
    </Button>
  );
};

export default ButtonWithIcon;
